import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./EstadoPago.css";

export default function Failure() {
  const history = useHistory();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = params.get("status") || "failure";

  const [seconds, setSeconds] = useState(15);

  useEffect(() => {
    const t = setInterval(() => setSeconds(s => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (seconds === 0) history.push("/");
  }, [seconds, history]);

  const goHome = () => history.push("/");
  const goBack = () => (history.length > 1 ? history.goBack() : history.push("/"));

  return (
    <section className="estado-wrap mt-under-header">
      <div className="estado-card estado-failure">
        <div className="estado-head">
          <span className="estado-icon" role="img" aria-label="error">❌</span>
          <h1 className="estado-title">Pago rechazado</h1>
        </div>

        <p className="estado-text">
          No pudimos procesar tu pago. Probá nuevamente, revisá los datos o elegí otro medio.
        </p>

        <ul className="estado-list">
          <li>Verificá el límite, el CVV y la fecha de vencimiento.</li>
          <li>Podés intentar con otra tarjeta o con tu cuenta de Mercado Pago.</li>
        </ul>

        <p className="estado-status"><b>status:</b> {status}</p>

        <div className="estado-actions">
          <button className="btn-outline failure" onClick={goHome}>Ir al inicio</button>
          <button className="btn-outline ghost failure" onClick={goBack}>Volver</button>
        </div>

        <p className="estado-note">Te redirigimos al inicio en {seconds}s…</p>
      </div>
    </section>
  );
}
